<template>
  <main class="h-screen ml-0 w-full lg:mr-10">
    <main
      class="grid grid-flow-row grid-cols-12 w-full m-5 rounded-md bg-white h-5/6"
    >
      <aside class="col-span-4">
        <main>
          <section class="p-2">
            <section>
              <h1 class="font-bold py-2">Notifications</h1>
            </section>
            <div class="search-container relative">
              <input
                type="search"
                name="notification"
                id="notification"
                placeholder="Start typing to search..."
                class="w-full rounded-full bg-gray-200 pl-8"
                style="border-radius: 5rem !important"
                v-model="searchString"
              />
              <span class="absolute top-2 right-3">
                <img
                  class="h-5 w-5 cursor-pointer object-contain inline"
                  src="@/assets/icons/search.png"
                />
              </span>
            </div>
          </section>
          <section class="h-96 overflow-y-scroll b-1">
            <NotificationList
              :getNotificationToRead="getNotificationToRead"
              :currentNotitificationFromRoute="currentNotitification"
              :searchString="searchString"
            />
          </section>
        </main>
      </aside>
      <main class="col-span-8 bg-grey-100 p-2 my-10">
        <section v-if="currentNotitification">
          <section
            class="flex-1 flex flex-col lg:flex-row gap-3 md:items-center pb-2 border-b-1.5 mb-3"
          >
            <section
              class="w-8 h-8 rounded-full bg-gray-700 text-white text-center"
            >
              <p class="flex items-center w-full h-full justify-center text-xs">
                {{ getInitials(currentNotitification.createdBy) }}
              </p>
            </section>
            <section>
              <title class="font-bold line-clamp-1 md:line-clamp-none">
                {{ currentNotitification.title }}
              </title>
            </section>
          </section>
          <main>
            <article class="px-8">
              <p>
                {{ currentNotitification.content }}
              </p>
            </article>
          </main>
        </section>
        <section v-else>
          <el-empty description="No notifications found"> </el-empty>
        </section>
      </main>
    </main>
  </main>
</template>

<script>
import NotificationList from "./NotificationList.vue";

export default {
  name: "Notifications",
  data() {
    return {
      currentNotitification: null,
      searchString: null,
    };
  },
  components: { NotificationList },
  created() {
    this.getCurrentNotification();
  },

  methods: {
    getCurrentNotification() {
      const { notification } = this.$route.params;
      if (notification) {
        this.currentNotitification = notification;
      } else {
        this.currentNotitification = null;
      }
    },
    getNotificationToRead(notification) {
      this.currentNotitification = notification;
    },
    markAsUnread(notification) {
      notification.status = 1;
    },
    getInitials(fullname) {
      const names = fullname.split(" ");
      return names
        .map((name) => name[0])
        .join("")
        .toUpperCase();
    },
  },
};
</script>
